import $api from '@/api/routes.js'
import { forceGetAuth } from '@lyh/jslogin'
//
export const getToken = async () => {
  return new Promise((resolve, reject) => {
    $api
      .getToken({
        dtAuth: sessionStorage.getItem('LYH_JSLOGIN_AUTH_KEY')
      })
      .then((res) => {
        if (typeof res === 'boolean' && !res) {
          resolve(false)
          return
        }
        sessionStorage.setItem('LYH_TOKEN', res.token)
        resolve(true)
      })
      .catch((imError) => {
        resolve(false)
      })
  })
}

/**
 * 判断是否登录并跳转相应的平台登录页
 * @param type
 * 1: 研值圈 web
 * 2: 研值圈 H5
 * 999：分享页且使用自身项目登录
 * 1000: app
 *
 * 当有token时，直接返回true，无需验证
 * 当token不存在，auth存在时，表示外部带入auth，此时获取token并保存本地
 * 当auth不存在时，表示外部也未登录，此时需要  跳转到外部登录，进行登录
 * 无auth，也未传入type，表示  只是验证无需跳转
 * 无auth，并传入type，表示需强制验证是否登录，未登录需跳转
 */
export const useLoginTo = async (type) => {
  let auth = sessionStorage.getItem('LYH_JSLOGIN_AUTH_KEY')
  let token = sessionStorage.getItem('LYH_TOKEN')

  if (token) return true

  if (!token && auth) {
    // 请求token
    let isResToken = await getToken()

    return isResToken
  }

  if (!auth && !type) return false

  if (!auth && type && type == '1000') {
    const res = await forceGetAuth()

    sessionStorage.setItem('LYH_JSLOGIN_AUTH_KEY', res)

    getToken()
  }

  if (!auth && type && type != '1000') {
    switch (type) {
      case '1':
        window.location.href = process.env.VUE_APP_WEB_URL + '/login?redirect_uri=' + encodeURIComponent(window.location.href)
        break

      case '2':
        window.location.href = process.env.VUE_APP_H5_URL + '/login?redirect_uri=' + encodeURIComponent(window.location.href)
        break

      case '999':
        getSession()
        break

      default:
        getSession()
        break
    }
  }
}
const getSession = async () => {
  const res = await forceGetAuth({ loginStyle: 2, canClose: true })

  sessionStorage.setItem('LYH_JSLOGIN_AUTH_KEY', res)
  await getToken()
  window.location.reload()
}
